import api from '../../services/api';
import { useState, useEffect } from "react";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import WarehouseOutlinedIcon from '@mui/icons-material/WarehouseOutlined';
import Pagination from '@mui/material/Pagination';
import Box from '@mui/material/Box';
import PageContainer from '../../common/components/PageContainer';
import PageHeader from '../../common/components/PageHeader';
import EntityCardGrid from '../../common/components/EntityCardGrid';
import EntityCard from '../../common/components/EntityCard';
import usePermissoes from '../../common/hooks/usePermissoes';
import Permissoes from '../../common/permissoes';

function Almoxarifado() {
    const { hasPermission } = usePermissoes();
    const [textoPesquisa, setTextoPesquisa] = useState("");
    const [data, setData] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);

    useEffect(() => {
        async function fetchData() {
            try {
                const response = await api.get(`/almoxarifado/pesquisa?texto=${textoPesquisa}&page=${page - 1}`);
                setData(response.data.content);
                setTotalPages(response.data.page.totalPages);
            } catch (error) {
                console.error("Erro ao buscar dados do almoxarifado:", error);
            }
        }
        fetchData();
    }, [page, textoPesquisa]);

    const handleChange = (event, value) => {
        setPage(value);
    };

    return (
        <PageContainer>
            <PageHeader
                title="Almoxarifado"
                searchValue={textoPesquisa}
                onSearchChange={(e) => {
                    setPage(1);
                    setTextoPesquisa(e.target.value);
                }}
                actionLabel={hasPermission(Permissoes.ALMOXARIFADO_CADASTRO) ? "Adicionar Item" : undefined}
                actionIcon={<AddCircleOutlineIcon />}
                actionTo="/almoxarifado/cadastro"
            />

            <EntityCardGrid
                items={data}
                keyExtractor={(item) => item.id}
                emptyMessage="Nenhum item encontrado."
                renderItem={(item) => (
                    <EntityCard
                        to={`/almoxarifado/${item.id}`}
                        image={item.foto ? `data:image/jpeg;base64,${item.foto}` : null}
                        icon={<WarehouseOutlinedIcon fontSize="inherit" />}
                        title={item.nome}
                        subtitle={`Qtd: ${item.estoque} ${item.unidMedida || ''}`}
                    />
                )}
            />

            {totalPages > 1 && (
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
                    <Pagination count={totalPages} page={page} onChange={handleChange} color="primary" />
                </Box>
            )}
        </PageContainer>
    );
}

export default Almoxarifado;
